import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-vb-payments-deposited-to',
  templateUrl: './vb-payments-deposited-to.component.html',
  styleUrls: ['./vb-payments-deposited-to.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentsDepositedToComponent {
  @Input() accountName: string = '';
}
